// One card per sub-feature, each carrying its PRD reference.
//
// Three states, and a fourth number that matters as much as any of them: how
// many candidates are being watched. "Nothing to block" and "we could not
// check" are different answers, and so is "there are candidates but the data
// cannot decide yet".
import React from 'react';
import { FiArrowRight, FiEye, FiLock } from 'react-icons/fi';
import s from '../KeywordOptimiser.module.css';
import { money } from '../format';

export default function FeatureCards({ data, loading, onOpen }) {
  if (loading && !data) {
    return (
      <div className={s.cardGrid}>
        {[0, 1, 2, 3, 4].map((i) => <div key={i} className={s.cardSkeleton} />)}
      </div>
    );
  }
  if (!data?.cards?.length) return null;

  return (
    <div className={s.cardGrid}>
      {data.cards.map((card) => {
        const clickable = card.state !== 'unavailable' || card.key === 'discovery';
        return (
          <section key={card.key}
                   className={`${s.card} ${s[`card_${card.state}`] || ''} ${clickable ? s.cardOpen : ''}`}
                   onClick={clickable ? () => onOpen(card.tab) : undefined}
                   role={clickable ? 'button' : undefined}
                   tabIndex={clickable ? 0 : undefined}
                   onKeyDown={clickable ? (e) => {
                     if (e.key === 'Enter' || e.key === ' ') {
                       e.preventDefault(); onOpen(card.tab);
                     }
                   } : undefined}>
            <header className={s.cardHead}>
              <span className={s.cardRef}>{card.ref}</span>
              {clickable ? <FiArrowRight className={s.cardGo} />
                : <FiLock className={s.cardLock} />}
            </header>
            <h3 className={s.cardTitle}>{card.title}</h3>
            <p className={s.cardQuestion}>{card.question}</p>
            <div className={s.cardHeadline}>
              <span className={s.cardValue}>{card.headline}</span>
            </div>
            <p className={s.cardDetail}>{card.detail}</p>
            {card.state === 'found' && (
              <ul className={s.cardList}>
                {card.suggestions > 0 && (
                  <li>
                    <span className={s.cardTerm}>To decide</span>
                    <span className={s.cardFigure}>{card.suggestions}</span>
                  </li>
                )}
                {card.saved != null && (
                  <li>
                    <span className={s.cardTerm}>Saves a month</span>
                    <span className={s.cardFigure}>
                      {money(card.saved, data.currency)}
                    </span>
                  </li>
                )}
                {card.moved != null && (
                  <li>
                    <span className={s.cardTerm}>Moves a month</span>
                    <span className={s.cardFigure}>
                      {money(card.moved, data.currency)}
                    </span>
                  </li>
                )}
                {card.affordable != null && (
                  <li>
                    <span className={s.cardTerm}>Affordable at a competitive bid</span>
                    <span className={s.cardFigure}>{card.affordable}</span>
                  </li>
                )}
                {card.watching > 0 && (
                  <li className={s.cardNote}>
                    <FiEye /> {card.watching} being watched — not enough data yet.
                  </li>
                )}
              </ul>
            )}
            {card.state !== 'found' && card.watching > 0 && (
              <ul className={s.cardList}>
                <li className={s.cardNote}>
                  <FiEye /> {card.watching} being watched.
                </li>
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
